module.exports = __webpack_public_path__ + "static/media/search.d13af64f.svg";